<template>
    <div>
        <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/relief.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001607497705&Signature=InC709v0V%2FHa7Qz63h8j9EyaXMw%3D"
             style="width:50%;display:block;margin:auto;" alt="">
    </div>
</template>

<script>
  export default {
    name: "",
    data: () => ({}),
    watch: {},
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>